// src/App.tsx
import { BrowserRouter as Router } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import AppRoutes from "./AppRoutes";
import { ApolloProvider } from '@apollo/client';
import client from './graphql/client';


const App = () => {
  return (
    <CartProvider>
       <ApolloProvider client={client}>
        <Router>
          <AppRoutes />
        </Router>
      </ApolloProvider>
    </CartProvider>
  );
};

export default App;
